import React from "react";

const ButtonBase = ({ children, className = "", ...props }) => {
    return (
        <button
            {...props}
            className={`
                bg-[#6446C3] 
                text-white 
                font-semibold 
                text-[3.5vw] sm:text-sm md:text-base
                px-3 sm:px-5 md:px-8 
                py-[3vw] sm:py-2 md:py-3.5 
                rounded-full 
                hover:bg-[#593bc0] 
                transition 
                whitespace-nowrap 
                overflow-hidden 
                text-ellipsis 
                ${className}
            `}
            style={{ minWidth: 0 }}
        >
            {children}
        </button>
    );
};

export default ButtonBase;
